import { render, staticRenderFns } from "./ReporteBalanceMensual.vue?vue&type=template&id=4b2b0b5a&scoped=true&"
import script from "./ReporteBalanceMensual.vue?vue&type=script&lang=js&"
export * from "./ReporteBalanceMensual.vue?vue&type=script&lang=js&"
import style0 from "./ReporteBalanceMensual.vue?vue&type=style&index=0&id=4b2b0b5a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../frontend-new/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b2b0b5a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../../frontend-new/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSheet } from 'vuetify/lib/components/VSheet';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VAvatar,VCard,VCardText,VCardTitle,VCol,VContainer,VDivider,VIcon,VList,VRow,VSheet,VToolbar,VToolbarTitle,VTooltip})
